

var elem = document.querySelector('.testimonials_slider');
if(elem) {
    var flkty = new Flickity( elem, {
        pageDots: false
    });
}

var swiper = new Swiper(".image_slider", {
	slidesPerView: 1,
	effect: 'fade',
	loop: true,
	autoplay: {
		delay: 5000,
	 },
	speed: 3000
});
var swiper2 = new Swiper(".logo_slider", {
	slidesPerView: "auto",
	loop: true,
	autoplay: {
		delay: 3000,
	 },
	speed: 3000,
	freeMode: true,
	speed: 5000,
	freeModeMomentum: false,
	disableOnInteraction: true,
	grabCursor: true,
});


// Price table tabs
const plan_tab_li = document.querySelectorAll(".plan_tab");
const pricing_data = document.querySelectorAll(".pricing-box h3");

plan_tab_li.forEach((li) => {
  li.addEventListener("click", (e) => {
    plan_tab_li.forEach((tab) => {
      tab.classList.remove("active");
    });
    e.currentTarget.classList.add("active");

    const clickedClassName = e.currentTarget.id;

    pricing_data.forEach((h3) => {
      h3.classList.remove("active");
    });
    pricing_data.forEach((h3) => {
      const h3Class = h3.getAttribute("class");
      if (h3Class == clickedClassName) {
        h3.classList.add("active");
      }
    });
  });
});


function showformPopup() {  
    document.getElementById("formpopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closeformPopup() {
    document.getElementById("formpopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}

document.documentElement.className = "js";

var menu = document.querySelector( '.menu' ),
    button = document.querySelector('.nav-toggle'),
    dropdown = document.querySelector('.dropdown');

if (button) {
  button.onclick = function() {
      classie.toggle( menu, 'menu-active' );
  };
}

// Close menu when clicking outside
// See: https://css-tricks.com/dangers-stopping-event-propagation/
document.addEventListener('click', function(event) {
  if (dropdown) {
    if (event.target !== dropdown && !dropdown.contains(event.target)) {
        // hide the menu
      classie.removeClass(menu, "menu-active");
    }
  }
});


( function( window ) {

'use strict';

var hasClass, addClass, removeClass;

if ( 'classList' in document.documentElement ) {
  hasClass = function( elem, c ) {
    return elem.classList.contains( c );
  };
  addClass = function( elem, c ) {
    elem.classList.add( c );
  };
  removeClass = function( elem, c ) {
    elem.classList.remove( c );
  };
}
else {
  hasClass = function( elem, c ) {
    return classReg( c ).test( elem.className );
  };
  addClass = function( elem, c ) {
    if ( !hasClass( elem, c ) ) {
      elem.className = elem.className + ' ' + c;
    }
  };
  removeClass = function( elem, c ) {
    elem.className = elem.className.replace( classReg( c ), ' ' );
  };
}

function toggleClass( elem, c ) {
  var fn = hasClass( elem, c ) ? removeClass : addClass;
  fn( elem, c );
}

var classie = {
  // full names
  hasClass: hasClass,
  addClass: addClass,
  removeClass: removeClass,
  toggleClass: toggleClass,
  // short names
  has: hasClass,
  add: addClass,
  remove: removeClass,
  toggle: toggleClass
};

// transport
if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( classie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = classie;
} else {
  // browser global
  window.classie = classie;
}

})( window );

(function() {
  'use strict';

  function initBlogCarousels() {
    const carousels = document.querySelectorAll('.blog-carousel__slider');
    
    carousels.forEach(carousel => {
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized = 'true';

      const slider = carousel.querySelector('[id^="Slider-"]');
      const slides = carousel.querySelectorAll('[id^="Slide-"]');
      const prevButton = carousel.querySelector('button[name="previous"]');
      const nextButton = carousel.querySelector('button[name="next"]');
      const dots = carousel.querySelectorAll('.blog-carousel__dot');
      
      if (!slider || slides.length === 0) return;

      let currentIndex = 0;
      let isScrolling = false;
      let scrollTimeout;

      function setupInfiniteLoop() {
        if (slides.length < 3) return;
        requestAnimationFrame(() => {
          const clonesToAdd = Math.min(3, slides.length);
          for (let i = 0; i < clonesToAdd; i++) {
            const clone = slides[i].cloneNode(true);
            clone.id = clone.id + '-clone-end';
            slider.appendChild(clone);
          }

          for (let i = slides.length - clonesToAdd; i < slides.length; i++) {
            const clone = slides[i].cloneNode(true);
            clone.id = clone.id + '-clone-start';
            slider.insertBefore(clone, slides[0]);
          }
          setTimeout(() => {
            const firstRealSlide = slider.querySelector('[id^="Slide-"]:not([id*="clone"])');
            if (firstRealSlide) {
              slider.scrollLeft = firstRealSlide.offsetLeft;
            }
          }, 100);
        });
      }

      setupInfiniteLoop();

      function handleInfiniteScroll() {
        if (isScrolling) return;
        
        const allSlides = slider.querySelectorAll('[id^="Slide-"]');
        const scrollLeft = slider.scrollLeft;
        const scrollWidth = slider.scrollWidth;
        const clientWidth = slider.clientWidth;
        if (scrollLeft + clientWidth >= scrollWidth - 10) {
          isScrolling = true;
          const firstRealSlide = slider.querySelector('[id^="Slide-"]:not([id*="clone"])');
          if (firstRealSlide) {
            slider.scrollLeft = firstRealSlide.offsetLeft;
          }
          setTimeout(() => { isScrolling = false; }, 100);
        }
        else if (scrollLeft <= 10) {
          isScrolling = true;
          const realSlides = slider.querySelectorAll('[id^="Slide-"]:not([id*="clone"])');
          const lastRealSlide = realSlides[realSlides.length - 1];
          if (lastRealSlide) {
            slider.scrollLeft = lastRealSlide.offsetLeft;
          }
          setTimeout(() => { isScrolling = false; }, 100);
        }
      }
      function updateDots() {
        if (isScrolling) return;
        
        const realSlides = slider.querySelectorAll('[id^="Slide-"]:not([id*="clone"])');
        let maxVisible = 0;
        let maxVisibleIndex = 0;

        realSlides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const sliderRect = slider.getBoundingClientRect();
          const visibleLeft = Math.max(rect.left, sliderRect.left);
          const visibleRight = Math.min(rect.right, sliderRect.right);
          const visibleWidth = Math.max(0, visibleRight - visibleLeft);
          const visibleRatio = visibleWidth / rect.width;

          if (visibleRatio > maxVisible) {
            maxVisible = visibleRatio;
            maxVisibleIndex = index;
          }
        });

        currentIndex = maxVisibleIndex;

        dots.forEach((dot, index) => {
          if (index === currentIndex) {
            dot.classList.add('blog-carousel__dot--active');
          } else {
            dot.classList.remove('blog-carousel__dot--active');
          }
        });
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const realSlides = slider.querySelectorAll('[id^="Slide-"]:not([id*="clone"])');
          const slide = realSlides[index];
          if (slide) {
            isScrolling = true;
            const slideLeft = slide.offsetLeft;
            const slideWidth = slide.offsetWidth;
            const sliderWidth = slider.offsetWidth;
            
            let scrollPosition;
            if (slide.classList.contains('blog-carousel__slide--wide')) {
              scrollPosition = slideLeft - (sliderWidth - slideWidth);
            } else {
              scrollPosition = slideLeft - (sliderWidth - slideWidth) / 2;
            }

            slider.scrollTo({
              left: scrollPosition,
              behavior: 'smooth'
            });
            
            setTimeout(() => { isScrolling = false; }, 500);
          }
        });
      });

      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          handleInfiniteScroll();
          updateDots();
        }, 50);
      });
      
      const sliderComponent = carousel.closest('slider-component');
      if (sliderComponent) {
        const originalUpdate = sliderComponent.update;
        if (originalUpdate) {
          sliderComponent.update = function() {
            originalUpdate.call(this);
            if (prevButton) prevButton.removeAttribute('disabled');
            if (nextButton) nextButton.removeAttribute('disabled');
          };
        }

        sliderComponent.addEventListener('slideChanged', (event) => {
          const slideElement = event.detail.currentElement;
          if (slideElement && !slideElement.id.includes('clone')) {
            const realSlides = slider.querySelectorAll('[id^="Slide-"]:not([id*="clone"])');
            const slideIndex = Array.from(realSlides).indexOf(slideElement);
            if (slideIndex !== -1) {
              currentIndex = slideIndex;
              dots.forEach((dot, index) => {
                if (index === currentIndex) {
                  dot.classList.add('blog-carousel__dot--active');
                } else {
                  dot.classList.remove('blog-carousel__dot--active');
                }
              });
            }
          }
          if (prevButton) prevButton.removeAttribute('disabled');
          if (nextButton) nextButton.removeAttribute('disabled');
        });

        const observer = new MutationObserver(() => {
          if (prevButton && prevButton.hasAttribute('disabled')) {
            prevButton.removeAttribute('disabled');
          }
          if (nextButton && nextButton.hasAttribute('disabled')) {
            nextButton.removeAttribute('disabled');
          }
        });

        if (prevButton) observer.observe(prevButton, { attributes: true, attributeFilter: ['disabled'] });
        if (nextButton) observer.observe(nextButton, { attributes: true, attributeFilter: ['disabled'] });
      }
      
      updateDots();
      if (prevButton) prevButton.removeAttribute('disabled');
      if (nextButton) nextButton.removeAttribute('disabled');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogCarousels);
  } else {
    initBlogCarousels();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initBlogCarousels);
    document.addEventListener('shopify:section:reorder', initBlogCarousels);
  }
})();

